module.exports = __webpack_public_path__ + "static/billsby-vault-fa9fd85723977af316ef8d0482fe8572.svg";